// components/Footer.jsx

import React from "react";
import styles from "../styles/Footer.module.css";
import { useNavigate, Link } from "react-router-dom";

export default function Footer() {

  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const homeButton = () => {
    if (window.location.pathname === "/") {
      scrollToSection("home");
    } else {
      navigate("/");
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>

        <div>
          <h2>Mesogeios</h2>
          <p>
            Mediterranean flavors, elegant atmosphere, unforgettable moments.
          </p>
        </div>

        <div>
          <h4>Navigation</h4>

          <button onClick={homeButton}>Home</button>
          <button onClick={() => scrollToSection("menu")}>Menu</button>
          <button onClick={() => scrollToSection("about")}>About</button>
          <button onClick={() => scrollToSection("gallery")}>Gallery</button>
        </div>

        <div>
          <h4>Contact</h4>

          <p>+30 2661 045827</p>
          <p>restaurantmesogeios@gmail.com</p>

          <a
            href="https://www.instagram.com/mesogeiosrestaurant/"
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            Instagram
          </a>

          {/* Legal Links */}
          <Link to="/privacy-policy" className={styles.link}>
            Privacy Policy
          </Link>

          <Link to="/cookie-policy" className={styles.link}>
            Cookie Policy
          </Link>
        </div>
      </div>

      <div className={styles.bottom}>
        © 2026 Mesogeios. Designed and Created by{" "}
        <a
          href="https://cytechsharp.com.cy"
          target="_blank"
          rel="noopener"
          className={styles.creator}
        >
          CyTechSharp
        </a>
      </div>
    </footer>
  );
}